<template>
  <div class="renwu">
    <!-- 定制项目列表  定制订单-->
    <div class="top">
      <Input v-model="patientNameLike" @on-clear="selectStatementRecordList(1)" @on-enter="selectStatementRecordList(1)" placeholder="请输入姓名进行搜索" clearable class="journal-input">
      <Icon type="ios-search" slot="prefix" /></Input>
      <Input @on-clear="selectStatementRecordList(1)" @on-enter="selectStatementRecordList(1)" v-model="idCardLike" placeholder="请输入身份证号进行搜索" clearable class="journal-input">
      <Icon type="ios-search" slot="prefix" /></Input>
      <Input @on-clear="selectStatementRecordList(1)" @on-enter="selectStatementRecordList(1)" v-model="phoneLike" placeholder="请输入身手机号进行搜索" clearable class="journal-input">
      <Icon type="ios-search" slot="prefix" /></Input>
      <Select class="select" placeholder="定制状态" clearable @on-change="qiChange">
        <Option v-for="(item, index) in typeList2" :value="item.value" :key="index">{{ item.name }}</Option>
      </Select>
    </div>
    <div class="table-cont">
      <Table @on-sort-change="changesort" stripe @on-selection-change="selectChange" :columns="columns" :data="data"></Table>
    </div>
    <div class="page-div">
      <div class="page-div-left">
        已选 <span>{{ selectNum }}</span> 条
      </div>
      <Page @on-page-size-change="changepeoplepage" @on-change="changePeoplecurrent" :total="obj.count" show-elevator show-total :current="current" :page-size="pageSize" show-sizer class="page-div-page" />
    </div>

    <!-- 详情-->
    <Modal class="ivumodal" footer-hide width="700" v-model="modify" :title="title">
      <div class="modal-cont">
        <Form ref="xiugai" :model="xiugai" :label-width="150">
          <FormItem label="定制名称：" class="bumenModal-item">
            <Input v-model="xiugai.customName" placeholder="请输入定制名称" style="color:#7F7F7F;width:300px;" />
          </FormItem>
          <FormItem label="是否锁定：" class="bumenModal-item">
            <RadioGroup v-model="xiugai.finalLocked">
              <Radio label="1">
                <span>是</span>
              </Radio>
              <Radio label="0" :disabled="xiugai.finalLocked == 1" style="margin-left:50px;">
                <span>否</span>
              </Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="定制收费项：" class="bumenModal-item" v-if="xiugai.finalLocked == 2">
            <Select class="select" multiple v-model="xiugai.questionId" placeholder="请先选择问卷再选择问题名称" :label-in-value="true" clearable @on-clear="tiChange('a')" @on-change="tiChange('a')" style="width:300px;">
              <Option v-for="(item, index) in tiList2" :value="item.questionId + ''" :key="index">{{ item.questionNameText }}</Option>
            </Select>
          </FormItem>
          <FormItem label="定制收费项：" class="bumenModal-item" v-if="xiugai.finalLocked == 1">
            <div style="line-height:35px; font-size:16px;" v-for="(item, index) in xiugai.customDetails" :key="index">
              {{ item.feeItemName }}
            </div>
          </FormItem>
        </Form>
        <div class="tishis">锁定后不支持修改哦</div>
        <div class="secondBumen-bottom">
          <Button class="btn" type="success" ghost @click="clear(1)">取消</Button>
          <Button class="btn sure" type="success" ghost @click="clear(2, 'xiugai')">确定</Button>
        </div>
      </div>
    </Modal>
    <Modal class="ivumodal" footer-hide width="950" v-model="dingmodify" :title="title">
      <div class="modal-cont modal-conts" style="width:40%;display:inline-block;vertic">
        <div style="line-height:30px;font-size:16px;">
          (答卷详情) 姓名：{{ partentObj.patientName }} 年龄：{{
            partentObj.age
          }}
          性别：{{ partentObj.sex == "1" ? "男" : "女" }}
        </div>
        <div v-for="(item, index) in objItem.answerDetail" :key="index">
          <div style="color:#53CAC3;font-size:16px;">
            {{ item.questionNameText }}
          </div>
          <div style="font-size:16px;">
            <span v-if="item.blank !== ''">{{ item.blank }}、</span>
            <span v-for="(i, ins) in item.optionsList" :key="ins">{{ i.optionsNameText }}、</span>
          </div>
        </div>
      </div>
      <div class="modal-cont" style="width:58%;display:inline-block;">
        <Form ref="addxiugai" :model="addxiugai" :rules="xiugaidata" :label-width="120">
          <FormItem label="定制名称：" prop="customName" class="bumenModal-item">
            <Input v-model="addxiugai.customName" placeholder="请输入定制名称" style="color:#7F7F7F;width:300px;" />
          </FormItem>
          <FormItem label="是否锁定：" prop="finalLocked" class="bumenModal-item">
            <RadioGroup v-model="addxiugai.finalLocked">
              <Radio label="1">
                <span>是</span>
              </Radio>
              <Radio label="0" style="margin-left:50px;">
                <span>否</span>
              </Radio>
            </RadioGroup>
          </FormItem>
          <FormItem :rules="{
              required: true,
              message: '请选择定制的收费项',
              trigger: 'change'
            }" :label="index == 0 ? '定制收费项：' : ''" :prop="'customDetails.' + index + '.feeItemId'" v-for="(item, index) in addxiugai.customDetails" :key="index" class="bumenModal-item">
            <Select class="select" v-model="item.feeItemId" placeholder="请选择定制的收费项" clearable style="width:230px;vertical-align: middle;">
              <Option v-for="(items, indexs) in xiangList" :value="items.feeItemId + ''" :key="indexs">{{ items.examName }}</Option>
            </Select>
            <Icon v-show="index !== 0" @click="slice(item, index)" class="i-icon" type="ios-remove-circle-outline" />
            <Icon v-show="index == 0" class="i-icon i-icons" type="ios-remove-circle-outline" />
            <Icon class="i-icon" @click="add(item, index)" type="ios-add-circle-outline" />
          </FormItem>
        </Form>
        <div class="tishis">锁定后患者才能看到您制定的项目哦</div>
        <div class="secondBumen-bottom">
          <Button class="btn" type="success" ghost @click="clears(1, 'addxiugai')">取消</Button>
          <Button class="btn sure" type="success" ghost @click="clears(2, 'addxiugai')">确定</Button>
        </div>
      </div>
    </Modal>

    <Alert class="alertTitle" v-show="alertTitleIshow" show-icon type="success">操作成功</Alert>
    <Alert class="alertTitle" v-show="alertTitleIshow2" type="error" show-icon>{{ alertTitle }}</Alert>

    <!-- <Spin fix v-show="isiconfontshow">
      <span class="iconfont demo-spin-icon-load ivu-icon">&#xe71d;</span>
      <div>距离有些遥远，小简 正在努力中……</div>
    </Spin> -->
  </div>
</template>
<script>
import {
  getAdvisoryOrder,
  getCustomRecommend,
  getAnswerListOutline,
  getDepartItem,
  saveCustomRecommend,
  updateCustomRecommend
} from "../servers/api";
export default {
  name: "dingDing",
  data () {
    return {
      isiconfontshow: false,
      alertTitleIshow: false,
      alertTitleIshow2: false,
      alertTitle: "",
      sliceIBumen: false,
      selectNum: 0,
      selectList: [],
      addxiugai: {
        answerId: "",
        customName: "",
        finalLocked: "0",
        customDetails: [
          {
            feeItemId: "",
            feeItemName: ""
          }
        ]
      },
      xiugai: {
        answerId: "",
        customName: "",
        finalLocked: "0",
        customDetails: []
      },
      modify: false,
      xiugaidata: {
        customName: [
          {
            required: true,
            message: "请输入定制名称",
            trigger: "blur"
          }
        ],
        finalLocked: [
          {
            required: true,
            message: "请选择推荐依据",
            trigger: "change"
          }
        ]
      },
      data: [],
      data2: [],
      name: "可预约",
      background: "#fff",
      columns: [
        {
          type: "selection",
          width: 50,
          align: "center"
        },
        {
          title: "姓名",
          width: 130,
          align: "center",
          key: "patientName",
          ellipsis: true,
          sortable: true
        },
        {
          title: "手机号",
          width: 160,
          align: "center",
          key: "phone",
          ellipsis: true,
          sortable: true
        },
        {
          title: "订单金额",
          width: 180,
          align: "center",
          key: "orderPrice",
          ellipsis: true,
          sortable: true
        },
        {
          title: "订单支付时间",
          minWidth: 250,
          align: "center",
          key: "payTime",
          ellipsis: true,
          sortable: true
        },
        {
          title: "订单状态",
          width: 200,
          align: "center",
          key: "orderStatus",
          ellipsis: true,
          sortable: true,
          render: (h, params) => {
            let a = "";
            switch (params.row.orderStatus) {
              case "1":
                a = "已提交未付款";
                break;
              case "2":
                a = "订单取消";
                break;
              case "3":
                a = "订单取消";
                break;
              case "4":
                a = "已支付";
                break;
              case "5":
                a = "已完成";
                break;
              case "6":
                a = "订单异常";
                break;
              case "7":
                a = "申请退款";
                break;
              case "8":
                a = "退款中";
                break;
              case "9":
                a = "已退款";
                break;
              case "10":
                a = "部分退款";
                break;
              case "12":
                a = "已付款";
                break;
              case "13":
                a = "退款失败";
                break;
              case "14":
                a = "候诊状态";
                break;
              case "15":
                a = "已接诊";
                break;
            }
            return h("div", [
              h(
                "span",
                {
                  style: {
                    display: "inline-block",
                    width: "100%",
                    height: "25px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    "line-height": "30px",
                    color: "#7F7F7F"
                  }
                },
                a
              )
            ]);
          }
        },

        {
          title: "订单更新时间",
          minWidth: 250,
          align: "center",
          key: "updateTime",
          ellipsis: true,
          sortable: true
        },
        {
          title: "定制服务状态",
          width: 200,
          align: "center",
          key: "customStatus",
          ellipsis: true,
          sortable: true,
          render: (h, params) => {
            let a = "";
            if (params.row.customStatus == "1") {
              a = "已定制";
            } else {
              a = "未定制";
            }
            return h("div", [
              h(
                "span",
                {
                  style: {
                    display: "inline-block",
                    width: "100%",
                    height: "25px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    "line-height": "30px",
                    color: "#7F7F7F"
                  }
                },
                a
              )
            ]);
          }
        },
        {
          title: "操作/调整",
          key: "awssd",
          align: "center",
          width: 150,
          fixed: "right",
          render: (h, params) => {
            if (params.row.customStatus == "1") {
              return h("div", [
                h(
                  "div",
                  {
                    style: {
                      height: "27px",
                      display: "inline-block",
                      "line-height": "27px",
                      "text-align": "center",
                      "font-size": "13px",
                      border: "1px solid #53CAC3",
                      "border-radius": "5px",
                      width: "50px",
                      cursor: "pointer",
                      disabled: false,
                      color: "#7F7F7F",
                      "margin-left": "2px"
                    },
                    on: {
                      click: () => {
                        this.clearItem(params.row);
                      }
                    }
                  },
                  "详情"
                )
              ]);
            } else if (
              params.row.orderStatus == "4" ||
              params.row.orderStatus == "12" ||
              params.row.orderStatus == "13" || params.row.orderStatus == "14" || params.row.orderStatus == "15"
            ) {
              //
              return h("div", [
                h(
                  "div",
                  {
                    style: {
                      width: "50px",
                      height: "27px",
                      "line-height": "27px",
                      "text-align": "center",
                      "font-size": "13px",
                      background: "#fff",
                      border: "1px solid #53CAC3",
                      "border-radius": "5px",
                      "margin-left": "2px",
                      cursor: "pointer",
                      display: "inline-block",
                      color: "#7F7F7F"
                    },
                    on: {
                      click: () => {
                        this.chengeTable(params.row);
                      }
                    }
                  },
                  "定制"
                )
              ]);
            }
          }
        }
      ],
      current: 1,
      pageSize: 20,
      obj: {},
      obj2: {},
      orderField: "",
      isAsc: "",
      receivedStartDate: "",
      receivedEndDate: "",
      orderField: "",
      isAsc: "",
      title: "详情",
      naireNameTextLike: "",
      clearnaireId: "",
      juanList: [],
      juanList2: [],
      naireId: "", //问卷id
      tiList: [],
      tiList2: [],
      questionId: "", //问题id
      xiangList: [],
      xiangList2: [],
      optionsId: "", //选项id
      keList: [],
      keList2: [],
      departId: "", //科室id
      tuiangList: [],
      tuiangList2: [],
      examId: "", //推荐项目id
      adviseLevel: "",
      yiList: [],
      yiList2: [],
      accordId: "", //推荐依据id
      current2: 1,
      types: "",
      patientNameLike: "", //姓名
      idCardLike: "", //身份证号
      phoneLike: "", //手机号
      dingmodify: false,
      objItem: {},
      isAdd: false,
      partentObj: {},
      typeList2: [
        {
          name: "未定制",
          value: "0"
        },
        {
          name: "已定制",
          value: "1"
        }
      ] //select选择筛选
    };
  },
  created () {
    this.selectStatementRecordList();
    this.getDepartItems();
  },
  methods: {
    filters (item) {
      let list = [];
      if (item == 2) {//女可用
        for (let i = 0; i < this.xiangList2.length; i++) {
          if (this.xiangList2[i].female == '1') {
            list.push(this.xiangList2[i])
          }
        }
      } else {//男可用
        for (let i = 0; i < this.xiangList2.length; i++) {
          if (this.xiangList2[i].male == '1') {
            list.push(this.xiangList2[i])
          }
        }

      }
      return list
    },
    selectStatementRecordList (index) {
      //获取列表
      this.isiconfontshow = true;
      if (index) {
        this.current = 1;
      }
      let params = {
        customStatus: this.customStatus,
        phoneLike: this.phoneLike,
        patientNameLike: this.patientNameLike,
        idCardLike: this.idCardLike,
        page: this.current,
        limit: this.pageSize,
        orderField: this.orderField,
        isAsc: this.isAsc,
        invisible: this.invisible
      };
      getAdvisoryOrder(params).then(res => {
        if (res.data.code == 10000) {
          this.isiconfontshow = false;
          this.obj = res.data.data || {};
          this.data = res.data.data.data || [];
        } else {
          this.isiconfontshow = false;
          this.alertTitle = res.data.msg;
          this.alertTitleIshow2 = true;
          setTimeout(() => {
            this.alertTitleIshow2 = false;
          }, 2000);
        }
      });
    },
    clearItem (item) {
      //详情
      getCustomRecommend({
        advisoryOrderId: item.advisoryOrderId,
        hasDetail: "Y"
      }).then(res => {
        if (res.data.code == 10000) {
          this.xiugai = JSON.parse(JSON.stringify(res.data.data.data[0]));
        }
      });
      this.modify = true;
      this.title = "定制详情";
    },
    qiChange (params) {
      //弹框里面的启用停用
      this.customStatus = params;
      this.selectStatementRecordList(1);
    },
    chengeTable (item) {
      //定制
      if (this.$refs["addxiugai"].resetFields()) {
        this.$refs["addxiugai"].resetFields();
      }
      getAnswerListOutline({
        //答卷详情
        answerId: item.answerId
      }).then(res => {
        if (res.data.code == 10000 && res.data.data.data.length > 0) {
          this.objItem = JSON.parse(JSON.stringify(res.data.data.data[0]));
          if (res.data.data.data[0].myself == 'N') {//不是本人
            this.partentObj = {
              patientName: res.data.data.data[0].qyPatientName,
              sex: res.data.data.data[0].qySex,
              age: res.data.data.data[0].qyAge
            }
          } else {
            this.partentObj = res.data.data.data[0]
          }
          this.xiangList = this.filters(this.partentObj.sex)//过滤加项性别
        } else {
          this.objItem = {};
        }
      });
      getCustomRecommend({
        //获取定制详情
        advisoryOrderId: item.advisoryOrderId,
        hasDetail: "Y"
      }).then(res => {
        if (res.data.code == 10000) {
          if (res.data.data.data.length > 0) {
            console.log(res.data.data.data[0])
            //定制了但是没锁定
            let list = [];
            for (
              let i = 0;
              i < res.data.data.data[0].customDetails.length;
              i++
            ) {
              list[i] = {
                feeItemId:
                  res.data.data.data[0].customDetails[i].feeItemId + "" || '',
                feeItemName: res.data.data.data[0].customDetails[i].feeItemName,
                examName: res.data.data.data[0].customDetails[i].feeItemName
              };
            }
            this.addxiugai = {
              advisoryOrderId: res.data.data.data[0].advisoryOrderId,
              answerId: res.data.data.data[0].answerId,
              customName: res.data.data.data[0].customName,
              finalLocked: res.data.data.data[0].finalLocked,
              customDetails: list,
              customId: res.data.data.data[0].customId
            };
            this.isAdd = false;
          } else {
            //还没定制
            this.isAdd = true;
            this.addxiugai = {
              advisoryOrderId: item.advisoryOrderId,
              answerId: item.answerId,
              customName: "",
              finalLocked: "0",
              customDetails: [
                {
                  feeItemId: "",
                  feeItemName: ""
                }
              ]
            };
          }
        }
      });
      this.title = "定制";
      this.dingmodify = true;
    },
    clears (index, name) {
      //定制点击确定 取消
      if (index == 1) {
        this.$refs[name].resetFields();
        this.dingmodify = false;
      } else {
        this.$refs[name].validate(valid => {
          if (valid) {
            for (let i = 0; i < this.addxiugai.customDetails.length; i++) {
              for (let j = 0; j < this.xiangList.length; j++) {
                if (
                  this.addxiugai.customDetails[i].feeItemId ==
                  this.xiangList[j].feeItemId
                ) {
                  this.addxiugai.customDetails[i].feeItemName = this.xiangList[
                    j
                  ].examName;
                  this.addxiugai.customDetails[i].examName = this.xiangList[
                    j
                  ].examName;
                }
              }
            }
            console.log(this.addxiugai);
            if (this.isAdd) {
              //新增定制
              this.postsaveCustomRecommend();
            } else {
              //修改定制
              this.postupdateCustomRecommend();
            }
          }
        });
      }
    },
    postupdateCustomRecommend () {
      //修改定制接口
      let obj = JSON.parse(JSON.stringify(this.addxiugai));
      obj.customDetails = JSON.stringify(obj.customDetails);
      updateCustomRecommend(obj).then(res => {
        if (res.data.code == 10000) {
          this.dingmodify = false;
          this.isiconfontshow = false;
          this.alertTitleIshow = true;
          setTimeout(() => {
            this.alertTitleIshow = false;
          }, 2000);
          this.addxiugai = {};
          this.selectStatementRecordList();
        } else {
          this.dingmodify = false;
          this.isiconfontshow = false;
          this.alertTitle = res.data.msg;
          this.alertTitleIshow2 = true;
          setTimeout(() => {
            this.alertTitleIshow2 = false;
          }, 2000);
        }
      });
    },
    getDepartItems () {
      //项目接口
      getDepartItem({}).then(res => {
        if (res.data.code == 10000) {
          this.xiangList2 = res.data.data.data;
          this.xiangList = res.data.data.data;
        }
      });
    },
    postsaveCustomRecommend () {
      //新增定制接口
      let obj = JSON.parse(JSON.stringify(this.addxiugai));
      obj.customDetails = JSON.stringify(obj.customDetails);
      saveCustomRecommend(obj).then(res => {
        if (res.data.code == 10000) {
          this.dingmodify = false;
          this.isiconfontshow = false;
          this.alertTitleIshow = true;
          setTimeout(() => {
            this.alertTitleIshow = false;
          }, 2000);
          this.addxiugai = {};
        } else {
          this.dingmodify = false;
          this.isiconfontshow = false;
          this.alertTitle = res.data.msg;
          this.alertTitleIshow2 = true;
          setTimeout(() => {
            this.alertTitleIshow2 = false;
          }, 2000);
        }
      });
    },
    slice (item, index) {
      //删除
      this.addxiugai.customDetails.splice(index, 1);
    },
    add (item, index) {
      //添加
      this.addxiugai.customDetails.push({
        feeItemId: "",
        feeItemName: ""
      });
    },
    clear (index, name) {
      //详情点击确定 取消
      this.modify = false;
    },
    selectChange (item) {
      //表格select选中
      this.selectList = item;
      this.selectNum = this.selectList.length;
    },
    changepeoplepage (num) {
      //换每页请求多少条
      this.pageSize = num;
      this.selectStatementRecordList(1);
    },
    changePeoplecurrent (num) {
      //换页
      this.current = num;
      this.selectStatementRecordList();
    },
    changePeoplecurrent2 (num) {
      //换页
      this.current2 = num;
      let params = {
        optionsId: this.xiugai.optionsId,
        page: this.current2,
        limit: 5
      };
      this.tablesGet(params);
    },
    changesort (item) {
      //排序
      this.orderField = item.key;
      this.isAsc = item.order;
      this.current = 1;
      if (item.order == "normal") {
        this.isAsc = "";
        this.orderField = "";
      }
      this.selectStatementRecordList(1);
    }
  }
};
</script>
<style lang="scss" scoped="" type="text/css">
@import "../css/conmmon.scss";
@import "../font/iconfont.css";
.ivu-form /deep/ {
  .ivu-form-item-error-tip {
    padding-top: 0 !important;
  }
}

.bumenModal-item {
  margin-top: 10px;
}

.ivumodal /deep/ {
  .ivu-modal {
    top: 70px !important;
  }
}

.modal-cont {
  width: 100%;
  min-height: 250px;
  max-height: 690px;
  overflow: hidden;
  overflow-y: visible;
  padding-bottom: 20px;
  padding-right: 20px;
  vertical-align: top;
}
.modal-conts {
  border-right: 1px solid #53cac3;
  height: 100%;
}
.modal-cont::-webkit-scrollbar {
  display: none;
}
.modal-cont {
  scrollbar-width: none; /* firefox */
  -ms-overflow-style: none; /* IE 10+ */
  overflow-x: hidden;
  overflow-y: auto;
}

.modal-img-cont {
  width: 100%;
  position: relative;
  border: 1px solid #53cac3;
  height: 120px;
  border-radius: 5px;
  margin-top: 10px;
}

.position {
  position: absolute;
  top: 5px;
  font-size: 25px;
  color: #53cac3;
  right: 5px;
  cursor: pointer;
}

.modal-img-cont-title {
  display: inline-block;
  height: 100%;
  width: 150px;
  line-height: 90px;
  vertical-align: top;
}

.modal-img-cont-img {
  display: inline-block;
  width: 150px;
  height: 105px;
  margin: 5px 15px;
}

.modal-num {
  width: 100%;
  text-align: right;
  color: #53cac3;
  line-height: 10px;
}

.modal-span {
  width: 178px;
  display: inline-block;
  line-height: 17px;
  vertical-align: middle;
}

.i-icon {
  font-size: 25px;
  font-weight: 700;
  line-height: 30px;
  vertical-align: middle;
  color: #53cac3;
  margin-left: 3px;
  cursor: pointer;
  display: inline-block;
}

.renwu {
  font-size: 13px;
  padding: 15px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: scroll;
  overflow-y: visible;
  .btn {
    float: right;
  }
  .top {
    width: calc(100% - 250px);
    height: 60px;
    line-height: 35px;
    position: fixed;
    top: 111px;
    z-index: 99;
    background: #fff;
    padding-top: 17px;
    left: 220px;
    padding-left: 15px;
    padding-bottom: 15px;
  }
  .select {
    width: 150px;
    // margin-right: 15px;
  }
  .journal-input {
    width: 180px;
    vertical-align: top;
  }
  .data {
    width: 190px;
    vertical-align: top;
  }
  .table-cont {
    margin: 40px 0 60px;
    padding-top: 40px;
  }
  .page-div {
    width: 100%;
    margin-top: 15px;
    position: fixed;
    background: #fff;
    width: calc(100% - 270px);
    height: 60px;
    z-index: 99;
    bottom: 0;
    padding-top: 15px;
    .page-div-left {
      float: left;
    }
    .page-div-page {
      float: right;
      margin-right: 15px;
    }
  }
  .title-btn {
    vertical-align: top;
    float: right;
  }
}
.tishis {
  color: rgba(245, 154, 35, 1);
  margin: 10px auto;
  text-align: center;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/questions/dingDing.vue